import React from 'react';
import { Alert, Table }  from 'reactstrap';
import * as Icon from 'react-feather';
import { ConfirmModal } from '../Modals/Confirm';

export function ConfirmDeleteGlobalAlertModal(props) {
    return (
        <ConfirmModal 
            isOpen={props.isOpen}
            toggle={props.toggle} 
            handleConfirm={(e) => props.handleConfirm(props.globalAlert, e)}
            title="Delete Global Alert?"
            confirmText="Yes, Delete Global Alert"
            confirmColor="danger"
            confirmIcon={Icon.Trash2}
        >
            <Alert color="warning">
                <strong>Are you sure you wish to delete the following Global Alert?</strong>
            </Alert>

            <Table bordered>
                <thead>
                    <tr>
                        <th className="col-xs-12">Title</th>       
                        <th className="col-xs-12">Description</th>                      
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{props.globalAlert.title}</td>
                        <td>{props.globalAlert.description}</td>
                    </tr>
                </tbody>
            </Table>
        </ConfirmModal>
    );
}